import axios from "axios";
import { GroupCreateDto, GroupDto, UpdateGroupDto } from "./group.types";
import { PublicMemberDto } from "../users/users.types";
import { UpdateGroupMemberDto } from "./organization.types";

const API_URL = `${import.meta.env.VITE_API_BASE_URL}group`; // `${import.meta.env.VITE_API_BASE_URL}auth`;

export async function createGroup(data: GroupCreateDto): Promise<GroupDto> {
  const token = localStorage.getItem("daex-auth-token");
  const res = await axios.post(`${API_URL}/${data.organizationId}`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.data) throw new Error("No data received");
  return res.data;
}

// Asynchronous function to register a user
const getGroups = async (): Promise<GroupDto[]> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const response = await axios.get(`${API_URL}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  if (response.data) return response.data;
  throw new Error("Fetching failed, no data received.");
};

const getGroup = async (groupId: string): Promise<GroupDto> => {
  const authToken = localStorage.getItem("daex-auth-token");
  const response = await axios.get(`${API_URL}/${groupId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });

  if (response.data) return response.data;
  throw new Error("Fetching failed, no data received.");
};

const updateGroup = async (groupData: UpdateGroupDto): Promise<GroupDto> => {
  const authToken = localStorage.getItem("daex-auth-token");

  const response = await axios.put(`${API_URL}/${groupData.id}`, groupData, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  if (response.data) return response.data;
  throw new Error("Updating failed, no data received.");
};

const deleteGroup = async (groupId: string): Promise<string> => {
  const authToken = localStorage.getItem("daex-auth-token");

  const response = await axios.delete(`${API_URL}/${groupId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  if (response) return groupId;
  throw new Error("Updating failed, no data received.");
};

const removeGroupMember = async (
  groupId: string,
  userId: string
): Promise<string> => {
  const authToken = localStorage.getItem("daex-auth-token");

  //:id/removeMember/:userId'
  const response = await axios.delete(
    `${API_URL}/${groupId}/removeMember/${userId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      withCredentials: true,
    }
  );
  if (response) return userId;
  throw new Error("Updating failed, no data received.");
};

const leaveGroup = async (groupId: string): Promise<string> => {
  const authToken = localStorage.getItem("daex-auth-token");

  const response = await axios.delete(`${API_URL}/${groupId}/leave`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    withCredentials: true,
  });
  if (response) return groupId;
  throw new Error("Updating failed, no data received.");
};

const createGroupMember = async (
  userId: string,
  groupId: string
): Promise<PublicMemberDto> => {
  const authToken = localStorage.getItem("daex-auth-token");

  const response = await axios.post(
    `${API_URL}/${groupId}/addMember/${userId}`,
    {}, // Pass an empty object as data (if you have no body to send)
    {
      headers: {
        Authorization: `Bearer ${authToken}`, // Correctly set the Authorization header
      },
    }
  );
  return response.data.user;
};

const updateGroupMember = async (
  updateData: UpdateGroupMemberDto
): Promise<PublicMemberDto> => {
  const authToken = localStorage.getItem("daex-auth-token");

  const response = await axios.put(
    `${API_URL}/${updateData.groupId}/updateMember`,
    updateData,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      withCredentials: true,
    }
  );
  if (response) return response.data;
  throw new Error("Updating failed, no data received.");
};

const groupService = {
  getGroup,
  getGroups,
  createGroup,
  updateGroup,
  createGroupMember,
  deleteGroup,
  removeGroupMember,
  updateGroupMember,
  leaveGroup,
};
export default groupService;
